import {
	JSEncrypt
} from 'jsencrypt'
const publicKey =
	`MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCR/PGSwsq5Psse54/psmPqcqYfsUF+LwMfwML0FPIAHJEqfd7Em3wePRydxh1v9kDq0kC8oQWs8pOCi8TUIrjODPmyKmbT6O+Ft9xOC0+wljIb5Jh05OyxGzGlqM7oPn3vyrIBtieOuY2czBuYIPt0xt7VKzlxpJDF+4s9M0Fd/wIDAQAB`
// 16进制转byte数组

function hexToBytes(hex) {
	for (var bytes = [], c = 0; c < hex.length; c += 2)
		bytes.push(parseInt(hex.substr(c, 2), 16));
	return bytes;
}

// byte数组转16进制

function bytesToHex(bytes) {
	for (var hex = [], i = 0; i < bytes.length; i++) {
		hex.push((bytes[i] >>> 4).toString(16));
		hex.push((bytes[i] & 0xF).toString(16));
	}
	return hex.join("");
}


JSEncrypt.prototype.encryptLong2 = function(string) {

	var k = this.getKey();

	try {

		var ct = ""; //RSA每次加密最大117bytes，需要辅助方法判断字符串截取位置

		//1.获取字符串截取点

		var bytes = new Array();

		bytes.push(0);

		var byteNo = 0;

		var len, c;

		len = string.length;

		var temp = 0;

		for (let i = 0; i < len; i++) {

			c = string.charCodeAt(i);

			if (c >= 0x010000 && c <= 0x10FFFF) {

				byteNo += 4;

			} else if (c >= 0x000800 && c <= 0x00FFFF) {

				byteNo += 3;

			} else if (c >= 0x000080 && c <= 0x0007FF) {

				byteNo += 2;

			} else {

				byteNo += 1;

			}

			if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {

				if (byteNo - temp >= 114) {

					bytes.push(i);

					temp = byteNo;

				}

			}

		}

		//2.截取字符串并分段加密

		if (bytes.length > 1) {

			for (let i = 0; i < bytes.length - 1; i++) {

				var str;

				if (i == 0) {

					str = string.substring(0, bytes[i + 1] + 1);

				} else {

					str = string.substring(bytes[i] + 1, bytes[i + 1] + 1);

				}

				var t1 = k.encrypt(str);

				ct += t1;

			}

			if (bytes[bytes.length - 1] != string.length - 1) {

				var lastStr = string.substring(bytes[bytes.length - 1] + 1);

				ct += k.encrypt(lastStr);

			}

			return hexToBytes(ct);

		}

		var t = k.encrypt(string);

		var y = hexToBytes(t);

		return y;

	} catch (ex) {

		return false;

	}

};


JSEncrypt.prototype.decryptLong2 = function(string) {

	var k = this.getKey();

	var MAX_DECRYPT_BLOCK = 128; //分段解密最大长度限制为128字节

	try {

		var ct = "";

		var t1;

		var bufTmp;

		var hexTmp;

		var str = bytesToHex(string); //这块可能有些没有必要，因为sting参数已经及转为byte数组

		var buf = hexToBytes(str);

		var inputLen = buf.length;

		//开始长度

		var offSet = 0;

		//结束长度

		var endOffSet = MAX_DECRYPT_BLOCK;

		//分段解密

		while (inputLen - offSet > 0) {

			if (inputLen - offSet > MAX_DECRYPT_BLOCK) {

				bufTmp = buf.slice(offSet, endOffSet);

				hexTmp = bytesToHex(bufTmp);

				t1 = k.decrypt(hexTmp);

				ct += t1;

				// console.log('分段' + offSet)

				// console.log(hexTmp)

				// console.log(t1)

			} else {

				bufTmp = buf.slice(offSet, inputLen);

				hexTmp = bytesToHex(bufTmp);

				t1 = k.decrypt(hexTmp);

				ct += t1;

				// console.log('分段' + offSet)

				// console.log(hexTmp)

				// console.log(t1)

			}

			offSet += MAX_DECRYPT_BLOCK;

			endOffSet += MAX_DECRYPT_BLOCK;

		}

		return ct;

	} catch (ex) {

		return false;

	}

};

// btye数组转base64
function arrayBufferToBase64(buffer) {

	var binary = '';

	var bytes = new Uint8Array(buffer);

	var len = bytes.byteLength;

	for (let i = 0; i < len; i++) {

		binary += String.fromCharCode(bytes[i]);

	}

	return window.btoa(binary);

}

// base64转btye数组
function base64ToArrayBuffer(base64) {

	var binary_string = window.atob(base64);

	var len = binary_string.length;

	var bytes = new Uint8Array(len);

	for (let i = 0; i < len; i++) {

		bytes[i] = binary_string.charCodeAt(i);

	}

	return bytes;

}

export const getrsa = function(password) {

	let encrypt = new JSEncrypt()

	encrypt.setPublicKey(`${publicKey}`) // 公钥

	let getrsadata = arrayBufferToBase64(encrypt.encryptLong2(password)); //将加密的数据转码为base64

	return getrsadata //加密后的数据

}

export const decrsa = function(passwords) {

	let encrypt = new JSEncrypt()

	encrypt.setPrivateKey('-----BEGIN PRIVATE KEY-----私钥-----') // 私钥

	let decrsadata = encrypt.decryptLong2(base64ToArrayBuffer(passwords)) // password要解密的数据 先转为byte数组在进行解码

	return decrsadata //解密后的数据

}

export const splitStr = function(str, len) {
	var Strlen = Math.ceil(str.length / len)
	var arr = []
	for (let i = 0; i < Strlen; i++) {
		arr.push(getrsa(str.substring(i * len, (i + 1) * len)))
	}
	return arr
}
